// extracted by mini-css-extract-plugin
export default {"header":"Header_header__wyatq","image":"Header_image__ok6CF","breaker":"Header_breaker__IY2G3"};